<template>
  <div class="agreement">
    <div class="header">
      <div class="back" @click="goBack">
        <span class="iconfont icon-fanhui2"></span>
      </div>
      <div class="title">隐私协议</div>
      <div class="back"></div>
    </div>
    <div class="content">
      <h2>隐私协议</h2>
      <p>
        我们非常重视您的隐私保护。本隐私协议说明了我们如何收集、使用和保护您的个人信息。
      </p>
      <h3>一、信息收集</h3>
      <p>我们可能收集您提供的个人信息，包括但不限于手机号码、姓名、地址等。</p>
      <h3>二、信息使用</h3>
      <p>
        我们使用收集的信息来提供和改进我们的服务，处理您的订单，以及与您沟通。
      </p>
      <h3>三、信息共享</h3>
      <p>
        我们不会将您的个人信息出售给第三方。仅在法律要求或为了保护我们的权利时才会披露。
      </p>
      <h3>四、信息安全</h3>
      <p>
        我们采取适当的安全措施来保护您的个人信息，防止未经授权的访问、披露或销毁。
      </p>
      <h3>五、Cookie 使用</h3>
      <p>我们使用 Cookie 和类似技术来改善您的浏览体验和分析服务使用情况。</p>
      <h3>六、您的权利</h3>
      <p>您有权访问、更正或删除您的个人信息。如需行使这些权利，请联系我们。</p>
      <h3>七、协议更新</h3>
      <p>我们可能不时更新本隐私协议。更新后的协议将在我们平台上发布。</p>
      <h3>八、联系我们</h3>
      <p>如果您对本隐私协议有任何疑问，请通过客服渠道联系我们。</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "UserPrivacyAgreement",
  methods: {
    goBack() {
      this.$router.push({ name: "Login" });
    },
  },
};
</script>
<style scoped>
.agreement {
  min-height: 100vh;
  background: #fff;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  padding: 0 15px;
  background: #fff;
  border-bottom: 1px solid #eee;
}
.header .back {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
}
.header .back .iconfont {
  font-size: 20px;
  color: #333;
}
.header .title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.content {
  padding: 20px 15px;
}
.content h2 {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 15px;
  color: #333;
}
.content h3 {
  font-size: 15px;
  font-weight: bold;
  margin: 15px 0 8px;
  color: #333;
}
.content p {
  font-size: 14px;
  line-height: 22px;
  color: #666;
  text-indent: 2em;
}
</style>
